module.exports = __webpack_public_path__ + "static/media/MobileUpload.e2425116.svg";